"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldErrorMessage = exports.createValidationMessage = void 0;
var _i18n = require("@ori/i18n");
var _jsxRuntime = require("react/jsx-runtime");
const getFieldErrorMessage = (fieldName, errors) => {
  const fieldKey = fieldName;
  const errorMessage = errors[fieldKey]?.message;
  if (errorMessage?.localization) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
      id: errorMessage.localization.id,
      defaultMessage: errorMessage.localization.defaultMessage ?? '',
      values: errorMessage.params
    });
  }
  return undefined;
};
exports.getFieldErrorMessage = getFieldErrorMessage;
const createValidationMessage = (localization, paramsObject = {}) => {
  const params = paramsObject;
  return {
    localization,
    params
  };
};
exports.createValidationMessage = createValidationMessage;
//# sourceMappingURL=FieldError.js.map